module.exports = __webpack_public_path__ + "static/slide2-94bd8f5d56271a29f0a61d4e690b43c0.jpg";